module.exports = __webpack_public_path__ + "media/images/emblems/Epalinges-coat_of_arms-775e92e6e5f126e977eb88f44c1ad01a.svg";